import { Directive, forwardRef, Provider } from "@angular/core";
import { CheckboxRequiredValidator, NG_VALIDATORS } from "@angular/forms";

export const VDS_CHECKBOX_REQUIRED_VALIDATOR: Provider = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => VdsCheckboxRequiredValidator),
    multi: true
};

/**
 * Validator for vdsCheckbox required attribute in template-driven checkbox.
 * Angulars current CheckboxRequiredValidator only work with `input type=checkbox` and does not
 * work with `vds-checkbox`.
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: `vds-checkbox[required][formControlName],
             vds-checkbox[required][formControl], vds-checkbox[required][ngModel]`,
    providers: [VDS_CHECKBOX_REQUIRED_VALIDATOR]
})
export class VdsCheckboxRequiredValidator extends CheckboxRequiredValidator {}
